import _ from "lodash";
import { push } from "connected-react-router";

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage } from "./ui";
import { getTemplateInfo, createTemplate, editTemplate, uploadImage } from "../../request";

//Редактирование формы шаблона
export const SET_TEMPLATE_NAME = "Set template name";
export const TOGGLE_TEMPLATE_BY_DEFAULT = "Toggle template by default";

//Создание шаблона
export const TEMPLATE_CREATION_START = "Template creation start";
export const TEMPLATE_CREATED_SUCCESSFULLY = "Template created successfully";
export const TEMPLATE_CREATION_FAILED = "Failure during template creation";

//Загрузка информации о редактируемом шаблоне
export const EDITING_TEMPLATE_LOADING_START = "Editing template form loading start";
export const EDITING_TEMPLATE_LOADED_SUCCESSFULLY = "Editing template form loaded successfully";
export const EDITING_TEMPLATE_LOADING_FAILED = "Failure during editing template form load";

//Редактирование шаблона
export const TEMPLATE_EDITING_START = "Template editing start";
export const TEMPLATE_EDITED_SUCCESSFULLY = "Template edited successfully";
export const TEMPLATE_EDITING_FAILED = "Failure during template editig";

//Загрузка картинки шаблона на сервер
export const TEMPLATE_IMAGE_UPLOAD_START = "Template image upload start";
export const TEMPLATE_IMAGE_UPLOADED_SUCCESSFULLY = "Template image uploaded successfully";
export const TEMPLATE_IMAGE_UPLOAD_FAILED = "Template image upload failed";
export const DELETE_TEMPLATE_IMAGE = "Delete template image";

//Отмена редактирования шаблона
export const CLEAR_TEMPLATE_FORM = "Clear template form";

//РЕДАКТИРОВАНИЕ ФОРМЫ ШАБЛОНА ВИЗИТКИ

//Название шаблона
export const setTemplateName = value => ({
  type: SET_TEMPLATE_NAME,
  payload: { value }
});

//Переключить тип шаблона
export const toggleTemplateByDefault = () => ({
  type: TOGGLE_TEMPLATE_BY_DEFAULT,
});

//Удалить картинку шаблона
export const deleteTemplateImage = () => ({
  type: DELETE_TEMPLATE_IMAGE,
});

//Очистка формы шаблона
export const clearTemplateForm = () => ({
  type: CLEAR_TEMPLATE_FORM
});

//СОЗДАНИЕ ШАБЛОНА ВИЗИТКИ
const startCreation = () => ({
  type: TEMPLATE_CREATION_START
});

const creationSuccess = () => ({
  type: TEMPLATE_CREATED_SUCCESSFULLY,
});

const creationFailure = () => ({
  type: TEMPLATE_CREATION_FAILED,
});

export const createTemplateAsync = () => {
  return async (dispatch, getState) => {
    dispatch(startCreation());
    await dispatch(checkAndRenewTokens());

    //Приведем данные шаблона к нужному формату
    const currentState = getState();
    const data = _.omit(currentState.editTemplate.template, ['id', 'thumbnail']);
    data.thumbnail_id = currentState.editTemplate.template.thumbnail.id;

    try {
      const accessToken = localStorage.getItem("accessToken");
      await createTemplate(accessToken, data);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при создании шаблона'));
      return dispatch(creationFailure());
    }
    dispatch(push('/templates'));
    dispatch(showSuccessMessage('Новый шаблон создан'));
    return dispatch(creationSuccess());

  };
};

//ЗАГРУЗКА ИНФОРМАЦИИ О РЕДАКТИРУЕМОМ ШАБЛОНЕ ВИЗИТКИ
const startLoading = () => ({
  type: EDITING_TEMPLATE_LOADING_START
});

const loadSuccess = template => ({
  type: EDITING_TEMPLATE_LOADED_SUCCESSFULLY,
  payload: { template },
}); 

const loadFailure = () => ({ 
  type: EDITING_TEMPLATE_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О ШАБЛОНЕ
export const getEditingTemplateAsync = templateId => {
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let template; 

    try {
      const accessToken = localStorage.getItem("accessToken");
      template = await getTemplateInfo(accessToken, templateId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при загрузке информации о шаблоне'));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(template));
  };
};

//РЕДАКТИРОВАНИЕ ШАБЛОНА ВИЗИТКИ
const startEditing = () => ({
  type: TEMPLATE_EDITING_START
});

const editingSuccess = () => ({
  type: TEMPLATE_EDITED_SUCCESSFULLY,
});

const editingFailure = () => ({
  type: TEMPLATE_EDITING_FAILED,
});

export const editTemplateAsync = templateId => {
  return async (dispatch, getState) => {
    dispatch(startEditing());
    await dispatch(checkAndRenewTokens());

    //Приведем данные шаблона к нужному формату
    const currentState = getState();
    const data = _.omit(currentState.editTemplate.template, ['id', 'thumbnail']);
    data.thumbnail_id = currentState.editTemplate.template.thumbnail.id;

    try {
      const accessToken = localStorage.getItem("accessToken");
      await editTemplate(accessToken, data, templateId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при редактировании шаблона'));
      return dispatch(editingFailure());
    }
    dispatch(push('/template/' + templateId));
    dispatch(showSuccessMessage('Шаблон отредактирован'));
    return dispatch(editingSuccess());
  };
};

//ЗАГРУЗКА КАРТИНКИ ШАБЛОНА НА СЕРВЕР
const startUpload = () => ({
  type: TEMPLATE_IMAGE_UPLOAD_START,
});

const uploadSuccess = (templateFile, fileName) => ({
  type: TEMPLATE_IMAGE_UPLOADED_SUCCESSFULLY,
  payload: { templateFile, fileName },
}); 

const uploadFailure = () => ({ 
  type: TEMPLATE_IMAGE_UPLOAD_FAILED,
});

//Загрузка картинки шаблона на сервер
export const uploadImageAsync = file => {
  return async (dispatch) => {
    dispatch(startUpload());
    await dispatch(checkAndRenewTokens());
    let templateFile; 

    try {
      const accessToken = localStorage.getItem("accessToken");
      templateFile = await uploadImage(accessToken, file);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при сохранении файла'));
      return dispatch(uploadFailure());
    }
    return dispatch(uploadSuccess(templateFile, file.name));
  };
};